import React, { forwardRef, useImperativeHandle } from 'react';
import { observer } from 'mobx-react';
import BackgroundPositionEdit from '../cssPropertyInput/BackgroundPositionEdit';
import BackgroundSizeEdit from '../cssPropertyInput/BackgroundSizeEdit';
import GridAreaEdit from '../cssPropertyInput/GridAreaEdit';
const VirtualPhotoMosaicMenu = observer( /*#__PURE__*/forwardRef(({
  id,
  cssObject,
  setCssProperty,
  htmlElement
}, ref) => {
  useImperativeHandle(ref, () => ({
    getFields: () => {
      return ['background-position', 'background-size', 'grid-row-start', 'grid-row-end', 'grid-column-start', 'grid-column-end'];
    }
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: "css-custom-menu-template"
  }, /*#__PURE__*/React.createElement(GridAreaEdit, {
    id: id,
    value: cssObject,
    setCssProperty: setCssProperty,
    htmlElement: htmlElement
  }), /*#__PURE__*/React.createElement(BackgroundPositionEdit, {
    id: id,
    value: cssObject[id]['background-position'],
    setValue: newValue => {
      setCssProperty(id, 'background-position', newValue);
    }
  }), /*#__PURE__*/React.createElement(BackgroundSizeEdit, {
    id: id,
    value: cssObject[id]['background-size'],
    setValue: newValue => {
      setCssProperty(id, 'background-size', newValue);
    }
  }));
}));
export default VirtualPhotoMosaicMenu;